import { asyncAction } from 'lib/actionCreators'

export const guestJobsList = asyncAction('candidate/JOBS_LIST')
export const guestNewJobsList = asyncAction('candidate/NEW_JOBS_LIST')
